if (!customElements.get('cooldo-plans-guide')) {
  customElements.define('cooldo-plans-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = [...this.querySelectorAll('[data-guide-tab]')];
      this.panels = [...this.querySelectorAll('[data-guide-panel]')];
      const tablist = this.querySelector('[data-guide-tabs]');
      if (!tablist || !this.tabs.length) return;
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-labelledby', this.getAttribute('aria-labelledby'));
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.addEventListener('click', () => this.select(index), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }, options);
      });
      this.panels.forEach((panel, index) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', this.tabs[index].id);
        panel.tabIndex = 0;
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.contains(event.target));
        if (index !== -1) this.select(index);
      }, options);
      this.select(0);
      this.dataset.ready = '';
      tablist.hidden = false;
    }
    select(index) {
      this.tabs.forEach((tab, current) => {
        const active = current === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[current].hidden = !active;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
